import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/wallet/components/LoyaltyShop/PrizeDetail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/stores/session/useSession.ts");
